import React, { useState } from "react";
import "./Course.css";
import { useNavigate } from "react-router-dom";
import { Form, Input, Button, Steps } from "antd";
import Course from "./CourseSummary";
const { Step } = Steps;

const CourseCreation = () => {
    const navigate = useNavigate();
	const [currentStep, setCurrentStep] = useState(0);
	const [formData, setFormData] = useState({
		course: "",
		target: "",
		duration: "",
	});

	const handleInputChange = (e) => {
		const { name, value } = e.target;
		setFormData((prevData) => ({
			...prevData,
			[name]: value,
		}));
		// console.log(currentStep);
	};

	const handleNext = () => {
		setCurrentStep(currentStep + 1);
	};

	const handlePrev = () => {
		console.log(currentStep);
		if (currentStep === 1) {
				setCurrentStep(parseInt(0));			
			console.log(currentStep);
		}
		if (currentStep === 2) {
			setCurrentStep(1);
		}
	};

	const handleFinish = () => {
		// console.log(formData);

        navigate(`create/course/${formData.course}/${formData.target}/${formData.duration}/`);
	};

	

	const renderCurrentStep = () => {
		switch (currentStep) {
			case 0:
				return renderStep1();
			case 1:
				return renderStep2();
			case 2:
				return renderStep3();
			default:
				return null;
		}
	};

	const renderStep1 = () => (
		<Form
			layout="vertical"
			name="form"
			initialValues={{ remember: true }}
			onFinish={handleNext}>
			<div className="course-creation-form">
				<Form.Item
					label="Describe your Course"
					name="course"
					rules={[
						{
							required: true,
							message: "Please enter the course description",
						},
					]}>
					<Input
						name="course"
						className="course-creation-input"
						onChange={handleInputChange}
						placeholder="Example: Machine Learning course...."
						allowClear
					/>
				</Form.Item>

				<div className="course-creation-buttons">
					<Button type="primary" htmlType="submit">
						Next
					</Button>
				</div>
			</div>
		</Form>
	);

	const renderStep2 = () => (
		<Form
			layout="vertical"
			name="form"
			initialValues={{ remember: true }}
			onFinish={handleNext}>
			<div className="course-creation-form">
				<Form.Item
					label="Course duration"
					name="duration"
					rules={[
						{
							required: true,
							message: "Please enter your course duration",
						},
					]}>
					<Input
						className="course-creation-input"
						name="duration"
						onChange={handleInputChange}
						placeholder="Example: 1 hour 30 minutes"
						allowClear
					/>
				</Form.Item>
				<div className="course-creation-buttons">
					<Button onClick={handlePrev}>Previous</Button>
					<Button type="primary" htmlType="submit">
						Next
					</Button>
				</div>
			</div>
		</Form>
	);

	const renderStep3 = () => (
		<Form
			layout="vertical"
			name="form"
			initialValues={{ remember: true }}
			onFinish={handleFinish}>
			<div className="course-creation-form">
				<Form.Item
					label="Target Audience"
					name="target"
					rules={[
						{
							required: true,
							message: "Please Enter Target Audience",
						},
					]}>
					<Input
						className="course-creation-input"
						name="target"
						onChange={handleInputChange}
						placeholder="Example: Beginner Btech Students"
						allowClear
					/>
				</Form.Item>
				<div className="course-creation-buttons">
					<Button onClick={handlePrev}>Previous</Button>
					<Button type="primary" htmlType="submit" className="lb">
						Submit
					</Button>
				</div>
			</div>
		</Form>
	);

	return (
		<div className="main-teacher-course">
			<div className="section-header">What Course Will You Prepare?</div>
			<div className="course-creation-grid">
				<div className="course-creation-steps">
					<Steps size="small" current={currentStep}>
						<Step title="Step 1" />
						<Step title="Step 2" />
						<Step title="Step 3" />
					</Steps>
				</div>

				<div className="contentstep">{renderCurrentStep()}</div>
			</div>
		</div>
	);
};

export default CourseCreation;
